[
  {
    "name": "三六零科技集团有限公司",
    "logo": "https://p3.ssl.qhimg.com/t011e94f0b9ed8e66b0.png",
    "link": "https://www.360.cn/",
    "membership": "Associate",
    "startDate": "2019-06",
    "gaRep": "李智杰",
    "gaAlt": "王先坤"
  },
  {
    "name": "阿里巴巴（中国）有限公司",
    "logo": "https://www.ecma-international.org/wp-content/uploads/Alibaba-logo.gif",
    "link": "https://www.alibabagroup.com/",
    "membership": "Associate",
    "startDate": "2019-12",
    "gaRep": "郑叶飞"
  },
  {
    "name": "腾讯",
    "logo": "https://www.tencent.com/img/index/tencent_logo.png",
    "link": "https://www.tencent.com/",
    "membership": "Associate",
    "startDate": "2020-06",
    "gaRep": "郑苏波"
  },
  {
    "name": "华为技术有限公司",
    "logo": "https://www-file.huawei.com/-/media/corporate/images/home/logo/huawei_logo.png",
    "link": "https://www.huawei.com/",
    "membership": "Associate",
    "startDate": "2019-12",
    "gaRep": "侯凡",
    "gaAlt": "王亚举"
  },
  {
    "name": "Sujitech",
    "logo": "https://www.ecma-international.org/wp-content/uploads/Sujitech-logo.gif",
    "link": "https://sujitech.com/",
    "membership": "SPC",
    "startDate": "2019-12",
    "gaRep": "刘怿斯"
  },
  {
    "name": "北京字节跳动网络技术有限公司",
    "logo": "https://www.ecma-international.org/wp-content/uploads/beijing_bytedance-logo.gif",
    "link": "https://www.bytedance.com/",
    "membership": "Associate",
    "startDate": "2021-06",
    "gaRep": "张荣剑"
  }
]
